export default "<canvas #canvas class=\"rain\"></canvas>\n";